"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTraceId = getTraceId;
/**
 * Generate an 8bit trace id.
 * @returns {string}
 */
function getTraceId() {
  var digits = '0123456789abcdef';
  var n = '';
  for (var i = 0; i < 16; i += 1) {
    var rand = Math.floor(Math.random() * 16);
    n += digits[rand];
  }
  return n;
}